// extracted by mini-css-extract-plugin
export default {"iframe_wrapper":"FlightInformation_iframe_wrapper__C8-OA","iframe":"FlightInformation_iframe__fOS4F"};